import * as actionTypes from './actionTypes'
import { newsletterService } from '../../service'
import { errorHelper } from '../../common/helpers'
import { constants } from '../../common/constants'

export function getNewsletters({ page = constants.GET_ALL_ITEMS, filter, reset } = {}) {
  return async dispatch => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_NEWSLETTERS })

      dispatch({ type: actionTypes.FETCH_NEWSLETTERS })

      const
        response = await newsletterService.getAll(page, filter),
        data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_NEWSLETTERS_FAILURE,
          payload: { error: data.message }
        })

        return
      }

      dispatch({
        type: actionTypes.FETCH_NEWSLETTERS_SUCCESS,
        payload: {
          newsletters: data.data,
          total: data.quantity,
          pageSize: data.pageSize
        }
      })
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_NEWSLETTERS_FAILURE)
    }
  }
}

export function resetNewsletters() {
  return dispatch => {
    dispatch({
      type: actionTypes.RESET_NEWSLETTERS
    })
  }
}

export function getNewsletter(id) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.RESET_NEWSLETTER })
      dispatch({ type: actionTypes.FETCH_NEWSLETTER })

      const
        response = await newsletterService.get(id),
        data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_NEWSLETTER_FAILURE,
          payload: { error: data.message }
        })
        return
      }

      dispatch({
        type: actionTypes.FETCH_NEWSLETTER_SUCCESS,
        payload: { newsletter: data }
      })
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_NEWSLETTER_FAILURE)
    }
  }
}

export function resetNewsletter() {
  return dispatch => {
    dispatch({
      type: actionTypes.RESET_NEWSLETTERS
    })
  }
}

export function createNewsletter(newsletter, preview_img, main_img, onSuccess) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.CREATE_NEWSLETTER })

      const
        response = await newsletterService.create(newsletter, preview_img, main_img),
        data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.CREATE_NEWSLETTER_FAILURE,
          payload: { error: data.message }
        })
        return
      }
      dispatch({
        type: actionTypes.CREATE_NEWSLETTER_SUCCESS,
        payload: { newsletter: data }
      })
      onSuccess()
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.CREATE_NEWSLETTER_FAILURE)
    }
  }
}

export function resetCreateNewsletter() {
  return dispatch => {
    dispatch({
      type: actionTypes.RESET_CREATE_NEWSLETTER
    })
  }
}

export function updateNewsletter(id, newsletter, preview_img, main_img, onSuccess) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.UPDATE_NEWSLETTER })

      const
        response = await newsletterService.update(id, newsletter, preview_img, main_img),
        data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.UPDATE_NEWSLETTER_FAILURE,
          payload: { error: data.message }
        })
        return
      }

      dispatch({
        type: actionTypes.UPDATE_NEWSLETTER_SUCCESS,
        payload: { newsletter: data }
      })

      onSuccess()
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.UPDATE_NEWSLETTER_FAILURE)
    }
  }
}

export function resetUpdateNewsletter() {
  return dispatch => {
    dispatch({
      type: actionTypes.RESET_UPDATE_NEWSLETTER
    })
  }
}

export function deleteNewsletter(id) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.DELETE_NEWSLETTER })

      const response = await newsletterService.deleteNewsletter(id)

      dispatch({
        type: actionTypes.DELETE_NEWSLETTER_SUCCESS,
        payload: { newsletter: { id } }
      })

      dispatch({ type: actionTypes.RESET_DELETE_NEWSLETTER })
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.DELETE_NEWSLETTER_FAILURE)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/newsletter/actions.js